import React from 'react';
import useResponsive from '../../hooks/useResponsive';

const NotMobile = ({ children }: any) => {
  const { isNotMobile } = useResponsive();
  return isNotMobile && children;
};

export default React.memo(NotMobile);
